import axios from 'axios';

const instance = axios.create({
    // baseURL: "https://dev.renloc.com/api/v1"
    baseURL: `${process.env.REACT_APP_API_URL}api/v1`
});

export default instance
